export default "__VITE_ASSET__Bvz0RN2P__"